import { Button, CircularProgress, Divider, FormControlLabel, FormGroup, Switch, TextField, Typography, Icon, IconButton } from '@material-ui/core'
import { useValues } from 'hooks'
import { createOfficeService, editOfficeService, EDIT_PATH, FIELDS } from 'lib'
import React from 'react'
import { useLocation, useHistory } from 'react-router'
import { IOffice } from 'types'

interface Props {
    onSuccess: () => void
    onError: (message?: string) => void
    onClose: () => void
}

const OfficeForm = (props: Props) => {
    const location = useLocation()
    const history = useHistory()
    const { onError, onSuccess, onClose } = props
    const initialInput = React.useRef<any>(null)
    const [loading, setLoading] = React.useState<boolean>(false)
    const { values: office, updateValue: handleChange, updateValues } = useValues()
    const handleSumbit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        try {
            setLoading(true)
            if (!(location.state as any)?.edit) {
                await createOfficeService({ ...office, active: true })
            } else {
                const edited = { ...office }
                delete edited[FIELDS.officeId.key]
                await editOfficeService(office[FIELDS.officeId.key], { ...edited })
            }
            setLoading(false)
            if (!(location.state as any)?.edit) {
                updateValues({ description: "", officeCode: "", active: true } as IOffice)
                initialInput.current?.focus()
            }
            onSuccess()
        } catch (error: any) {
            setLoading(false)
            onError(error.message ?? undefined)
        }
    }
    React.useEffect(() => {
        if ((location.state as any)?.edit) {
            if ((location.state as any)?.values) {
                updateValues((location.state as any)?.values)
            }
        }
        else {
            history.replace(location.pathname.replace(EDIT_PATH, ""))
        }
    }, [location.state, updateValues, history, location.pathname])
    return (
        <div className="p-4">
            <div className="flex items-center justify-between">
                <Typography variant="body2" style={{ fontWeight: 600, letterSpacing: 0.5 }}>
                    {(location.state as any)?.edit ? "Editar sucursal" : "Nueva sucursal"}
                </Typography>
                <IconButton onClick={onClose} size="small">
                    <Icon fontSize="small">close</Icon>
                </IconButton>
            </div>
            <form onSubmit={handleSumbit} className="pt-4 flex flex-col" style={{ width: 300 }}>
                <TextField
                    inputRef={initialInput}
                    autoFocus
                    size="small"
                    label={FIELDS.officeCode.name}
                    variant="outlined"
                    fullWidth
                    required
                    value={office[FIELDS.officeCode.key]}
                    onChange={(e) => handleChange(FIELDS.officeCode.key, e.target.value)}
                />
                <TextField
                    size="small"
                    label={FIELDS.description.name}
                    variant="outlined"
                    fullWidth
                    style={{ marginTop: 10 }}
                    multiline
                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault() } }}
                    rows={3}
                    required
                    value={office[FIELDS.description.key]}
                    onChange={(e) => handleChange(FIELDS.description.key, e.target.value)}
                />
                {
                    (location.state as any)?.edit &&
                    <FormGroup className="p-2" row>
                        <FormControlLabel
                            control={<Switch color="primary" size="small" checked={Boolean(office[FIELDS.active.key])} onChange={(e) => handleChange(FIELDS.active.key, e.target.checked)} name={FIELDS.active.name} />}
                            label={FIELDS.active.name}
                        />
                    </FormGroup>
                }
                <p>{office[FIELDS.active.key]}</p>
                <div className="mt-4">
                    <Divider />
                </div>
                <div className="flex justify-end pt-3">
                    <Button
                        size="small"
                        color="primary"
                        variant="contained"
                        disableElevation
                        disabled={loading}
                        type="submit"
                    >
                        {loading ? <CircularProgress style={{ color: "white" }} size={16} className="my-1" thickness={10} /> : (location.state as any)?.edit ? "Guardar" : "Registrar"}
                    </Button>
                </div>
            </form>
        </div >
    )
}

export default OfficeForm
